module.exports = __webpack_public_path__ + "static/media/halfCircleLightGreen1.dc941377.svg";